var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-carousel',{staticStyle:{"width":"100%"},attrs:{"interval":5000,"arrow":"hover","height":_vm.height,"indicator-position":"none"}},_vm._l((_vm.imgList),function(item){return _c('el-carousel-item',{key:item},[_c('img',{attrs:{"src":item,"alt":"bannner图"}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }